export enum EServiceStatus {
  MODERATION = 'MODERATION',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED'
}

export interface IServiceCategory {
  _id: string
  name: string
  photo?: string
  // null/пусто — категория основного сайта, иначе привязана к лендинг-странице (ПолоКлуб)
  page_id?: string | null
}

export interface IServiceSlotDay {
  weekday: number // 1=Пн ... 7=Вс
  times: string[] // время начала слотов "HH:mm"
}

export interface IServiceLocation {
  name: string
  lat: number
  lng: number
}

export interface IAdminService {
  _id: string
  name: string
  description?: string
  price: number
  photo: string
  photos?: string[] // галерея фото услуги, обложка = photos[0]
  status: EServiceStatus
  slug?: string
  category: IServiceCategory | string
  location?: IServiceLocation
  phone?: string
  contact_name?: string
  page_id?: string | null
  duration?: number
  slots?: IServiceSlotDay[]
  capacity?: number
  prepayment_required?: boolean
  staff_email?: string // устаревшее: один адрес у услуг, заведённых раньше
  staff_emails?: string[]
}

export interface IAdminServicesResponse {
  services: IAdminService[]
  count: number
}

export interface IPageBooking {
  _id: string
  number: number
  name: string
  phone: string
  email?: string
  user_id?: string | null
  datetime: string
  seats?: number
  amount: number
  status: string
  createdAt: string // от неё отсчитывается срок на оплату у записей в PENDING
  service_id: { _id: string; name: string; capacity?: number } | string
}

// занятость слотов услуги: полностью занятые + занятые места по слотам + вместимость
export interface IServiceOccupancy {
  taken: string[]
  booked: Record<string, number> // ISO datetime → занято мест
  capacity: number
}

// ручная запись клиента администрацией (без предоплаты; аккаунт ищется по телефону)
export interface ICreateBookingAdmin {
  service_id: string
  name: string
  phone: string
  email?: string
  datetime: string // ISO
  seats?: number
}

// тело формы создания услуги администрацией для лендинг-страницы
export interface ICreatePageService {
  page_id: string
  name: string
  description?: string
  category: string
  price: number
  duration?: number
  slots?: IServiceSlotDay[]
  capacity?: number
  prepayment_required?: boolean
  staff_emails?: string[] // куда дублировать уведомления о записи на эту услугу
  location: IServiceLocation
  phone?: string // контактный телефон услуги (показывается на карточке)
  contact_name?: string
  photos?: File[] // новые загружаемые фото
  existing_photos?: string[] // имена уже загруженных фото, которые оставляем (порядок сохраняется)
}
